import { Component } from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NgClass} from '@angular/common';

@Component({
  selector: 'gr-landing-header',
  templateUrl: './landing-header.component.html',
  imports: [
    RouterLinkActive,
    RouterLink,
    NgClass
  ],
  standalone: true
})
export class LandingHeaderComponent {
  isMenuOpen = false;

  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
}
